import k from "./index47.js";
import x from "./index46.js";
import { DIRECTION as r } from "./index125.js";
import y from "./index48.js";
import T, { normalizeOpts as b } from "./index30.js";
import m from "./index128.js";
import I from "./index129.js";
import C from "./index130.js";
import _ from "./index55.js";
import "./index58.js";
class h extends y {
  /** */
  /** */
  /** Single char for empty input */
  /** Single char for filled input */
  /** Show placeholder only when needed */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  constructor(e) {
    super({
      ...h.DEFAULTS,
      ...e,
      definitions: Object.assign({}, _.DEFAULT_DEFINITIONS, e == null ? void 0 : e.definitions)
    });
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    e.definitions = Object.assign({}, this.definitions, e.definitions), super._update(e), this._rebuildMask();
  }
  _rebuildMask() {
    const e = this.definitions;
    this._blocks = [], this.exposeBlock = void 0, this._stops = [], this._maskedBlocks = {};
    const s = this.mask;
    if (!s || !e)
      return;
    let t = !1, l = !1;
    for (let i = 0; i < s.length; ++i) {
      if (this.blocks) {
        const p = s.slice(i), g = Object.keys(this.blocks).filter((u) => p.indexOf(u) === 0);
        g.sort((u, d) => d.length - u.length);
        const c = g[0];
        if (c) {
          const {
            expose: u,
            repeat: d,
            ...E
          } = b(this.blocks[c]), B = {
            lazy: this.lazy,
            eager: this.eager,
            placeholderChar: this.placeholderChar,
            displayChar: this.displayChar,
            overwrite: this.overwrite,
            autofix: this.autofix,
            ...E,
            repeat: d,
            parent: this
          }, f = d != null ? new x.RepeatBlock(
            B
            /* TODO */
          ) : T(B);
          f && (this._blocks.push(f), u && (this.exposeBlock = f), this._maskedBlocks[c] || (this._maskedBlocks[c] = []), this._maskedBlocks[c].push(this._blocks.length - 1)), i += c.length - 1;
          continue;
        }
      }
      let o = s[i], a = o in e;
      if (o === h.STOP_CHAR) {
        this._stops.push(this._blocks.length);
        continue;
      }
      if (o === "{" || o === "}") {
        t = !t;
        continue;
      }
      if (o === "[" || o === "]") {
        l = !l;
        continue;
      }
      if (o === h.ESCAPE_CHAR) {
        if (++i, o = s[i], !o)
          break;
        a = !1;
      }
      const n = a ? new _({
        isOptional: l,
        lazy: this.lazy,
        eager: this.eager,
        placeholderChar: this.placeholderChar,
        displayChar: this.displayChar,
        ...b(e[o]),
        parent: this
      }) : new C({
        char: o,
        eager: this.eager,
        isUnmasking: t
      });
      this._blocks.push(n);
    }
  }
  get state() {
    return {
      ...super.state,
      _blocks: this._blocks.map((e) => e.state)
    };
  }
  set state(e) {
    if (!e) {
      this.reset();
      return;
    }
    const {
      _blocks: s,
      ...t
    } = e;
    this._blocks.forEach((l, i) => l.state = s[i]), super.state = t;
  }
  reset() {
    super.reset(), this._blocks.forEach((e) => e.reset());
  }
  get isComplete() {
    return this.exposeBlock ? this.exposeBlock.isComplete : this._blocks.every((e) => e.isComplete);
  }
  get isFilled() {
    return this._blocks.every((e) => e.isFilled);
  }
  get isFixed() {
    return this._blocks.every((e) => e.isFixed);
  }
  get isOptional() {
    return this._blocks.every((e) => e.isOptional);
  }
  doCommit() {
    this._blocks.forEach((e) => e.doCommit()), super.doCommit();
  }
  get unmaskedValue() {
    return this.exposeBlock ? this.exposeBlock.unmaskedValue : this._blocks.reduce((e, s) => e += s.unmaskedValue, "");
  }
  set unmaskedValue(e) {
    if (this.exposeBlock) {
      const s = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.unmaskedValue = e, this.appendTail(s), this.doCommit();
    } else
      super.unmaskedValue = e;
  }
  get value() {
    return this.exposeBlock ? this.exposeBlock.value : (
      // TODO return _value when not in change?
      this._blocks.reduce((e, s) => e += s.value, "")
    );
  }
  set value(e) {
    if (this.exposeBlock) {
      const s = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.value = e, this.appendTail(s), this.doCommit();
    } else
      super.value = e;
  }
  get typedValue() {
    return this.exposeBlock ? this.exposeBlock.typedValue : super.typedValue;
  }
  set typedValue(e) {
    if (this.exposeBlock) {
      const s = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.typedValue = e, this.appendTail(s), this.doCommit();
    } else
      super.typedValue = e;
  }
  get displayValue() {
    return this._blocks.reduce((e, s) => e += s.displayValue, "");
  }
  appendTail(e) {
    return super.appendTail(e).aggregate(this._appendPlaceholder());
  }
  _appendEager() {
    var e;
    const s = new k();
    let t = (e = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : e.index;
    if (t == null)
      return s;
    this._blocks[t].isFilled && ++t;
    for (let l = t; l < this._blocks.length; ++l) {
      const i = this._blocks[l]._appendEager();
      if (!i.inserted)
        break;
      s.aggregate(i);
    }
    return s;
  }
  _appendCharRaw(e, s) {
    s === void 0 && (s = {});
    const t = this._mapPosToBlock(this.displayValue.length), l = new k();
    if (!t)
      return l;
    for (let o = t.index, a; a = this._blocks[o]; ++o) {
      var i;
      const n = a._appendChar(e, {
        ...s,
        _beforeTailState: (i = s._beforeTailState) == null || (i = i._blocks) == null ? void 0 : i[o]
      });
      if (l.aggregate(n), n.consumed)
        break;
    }
    return l;
  }
  extractTail(e, s) {
    e === void 0 && (e = 0), s === void 0 && (s = this.displayValue.length);
    const t = new m();
    return e === s || this._forEachBlocksInRange(e, s, (l, i, o, a) => {
      const n = l.extractTail(o, a);
      n.stop = this._findStopBefore(i), n.from = this._blockStartPos(i), n instanceof m && (n.blockIndex = i), t.extend(n);
    }), t;
  }
  extractInput(e, s, t) {
    if (e === void 0 && (e = 0), s === void 0 && (s = this.displayValue.length), t === void 0 && (t = {}), e === s)
      return "";
    let l = "";
    return this._forEachBlocksInRange(e, s, (i, o, a, n) => {
      l += i.extractInput(a, n, t);
    }), l;
  }
  _findStopBefore(e) {
    let s;
    for (let t = 0; t < this._stops.length; ++t) {
      const l = this._stops[t];
      if (l <= e)
        s = l;
      else
        break;
    }
    return s;
  }
  /** Appends placeholder depending on laziness */
  _appendPlaceholder(e) {
    const s = new k();
    if (this.lazy && e == null)
      return s;
    const t = this._mapPosToBlock(this.displayValue.length);
    if (!t)
      return s;
    const l = t.index, i = e ?? this._blocks.length;
    return this._blocks.slice(l, i).forEach((o) => {
      if (!o.lazy || e != null) {
        var a;
        s.aggregate(o._appendPlaceholder((a = o._blocks) == null ? void 0 : a.length));
      }
    }), s;
  }
  /** Finds block in pos */
  _mapPosToBlock(e) {
    let s = "";
    for (let t = 0; t < this._blocks.length; ++t) {
      const l = this._blocks[t], i = s.length;
      if (s += l.displayValue, e <= s.length)
        return {
          index: t,
          offset: e - i
        };
    }
  }
  _blockStartPos(e) {
    return this._blocks.slice(0, e).reduce((s, t) => s += t.displayValue.length, 0);
  }
  _forEachBlocksInRange(e, s, t) {
    s === void 0 && (s = this.displayValue.length);
    const l = this._mapPosToBlock(e);
    if (l) {
      const i = this._mapPosToBlock(s), o = i && l.index === i.index, a = l.offset, n = i && o ? i.offset : this._blocks[l.index].displayValue.length;
      if (t(this._blocks[l.index], l.index, a, n), i && !o) {
        for (let p = l.index + 1; p < i.index; ++p)
          t(this._blocks[p], p, 0, this._blocks[p].displayValue.length);
        t(this._blocks[i.index], i.index, 0, i.offset);
      }
    }
  }
  remove(e, s) {
    e === void 0 && (e = 0), s === void 0 && (s = this.displayValue.length);
    const t = super.remove(e, s);
    return this._forEachBlocksInRange(e, s, (l, i, o, a) => {
      t.aggregate(l.remove(o, a));
    }), t;
  }
  nearestInputPos(e, s) {
    if (s === void 0 && (s = r.NONE), !this._blocks.length)
      return 0;
    const t = new I(this, e);
    if (s === r.NONE)
      return t.pushRightBeforeInput() || (t.popState(), t.pushLeftBeforeInput()) ? t.pos : this.displayValue.length;
    if (s === r.LEFT || s === r.FORCE_LEFT) {
      if (s === r.LEFT) {
        if (t.pushRightBeforeFilled(), t.ok && t.pos === e)
          return e;
        t.popState();
      }
      if (t.pushLeftBeforeInput(), t.pushLeftBeforeRequired(), t.pushLeftBeforeFilled(), s === r.LEFT) {
        if (t.pushRightBeforeInput(), t.pushRightBeforeRequired(), t.ok && t.pos <= e || (t.popState(), t.ok && t.pos <= e))
          return t.pos;
        t.popState();
      }
      return t.ok ? t.pos : s === r.FORCE_LEFT ? 0 : (t.popState(), t.ok || (t.popState(), t.ok) ? t.pos : 0);
    }
    return s === r.RIGHT || s === r.FORCE_RIGHT ? (t.pushRightBeforeInput(), t.pushRightBeforeRequired(), t.pushRightBeforeFilled() ? t.pos : s === r.FORCE_RIGHT ? this.displayValue.length : (t.popState(), t.ok || (t.popState(), t.ok) ? t.pos : this.nearestInputPos(e, r.LEFT))) : e;
  }
  totalInputPositions(e, s) {
    e === void 0 && (e = 0), s === void 0 && (s = this.displayValue.length);
    let t = 0;
    return this._forEachBlocksInRange(e, s, (l, i, o, a) => {
      t += l.totalInputPositions(o, a);
    }), t;
  }
  /** Get block by name */
  maskedBlock(e) {
    return this.maskedBlocks(e)[0];
  }
  /** Get all blocks by name */
  maskedBlocks(e) {
    const s = this._maskedBlocks[e];
    return s ? s.map((t) => this._blocks[t]) : [];
  }
  pad(e) {
    const s = new k();
    return this._forEachBlocksInRange(0, this.displayValue.length, (t) => s.aggregate(t.pad(e))), s;
  }
}
h.DEFAULTS = {
  ...y.DEFAULTS,
  lazy: !0,
  placeholderChar: "_"
};
h.STOP_CHAR = "`";
h.ESCAPE_CHAR = "\\";
h.InputDefinition = _;
h.FixedDefinition = C;
x.MaskedPattern = h;
export {
  h as default
};
